export const PaymentTypeApi = {
  INSTALLMENT: 'installment',
  FULL: 'full',
};

export const PaymentType = {
  [PaymentTypeApi.INSTALLMENT]: 'Installment',
  [PaymentTypeApi.FULL]: 'Full',
};
